import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Quote from "@/pages/Quote";
import Assistant from "@/pages/Assistant";
import Cocktails from "@/pages/Cocktails";
import Admin from "@/pages/Admin";

function App() {
  return (
    <div className="App">
      <ReactLenis root options={{ lerp: 0.08, smoothWheel: true }}>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/quote" element={<Quote />} />
            <Route path="/assistant" element={<Assistant />} />
            <Route path="/cocktails" element={<Cocktails />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </ReactLenis>
    </div>
  );
}

export default App;
